<template>
	<div class="drawer">
		<el-drawer
		size="80%"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>	
			<div slot="title">
				<span>待支付订单</span>
				<span style="font-size: 14px;color:red;">（总金额：{{allTotal}}元）</span>
			</div>
			<div style="padding:40px 30px;" v-for="(item,index) in unPayOrderList" :key="index">
				<div>
					<el-checkbox :checked="unPayOrderNoList.indexOf(item.no)===-1" @change="changeChecked(item.no)"></el-checkbox>
					订单{{index+1}}：
				</div>
				<el-row style="padding:20px 20px 10px;float: none;font-size: 16px;">
					<el-col :span="6">
						<span class="label">订单类型：</span>
						<span class="value">{{item.order_type}}订单</span>
					</el-col>
					<el-col :span="6">
						<span class="label">优惠券：</span>
						<span class="value" v-if="item.coupon_list.length>0">{{item.coupon_list[0].coupon_name}}({{item.coupon_list[0]._no}})</span>
						<span class="value" v-else>无</span>
					</el-col>
					<el-col :span="6">
						<span class="label">合计金额：</span>
						<span class="value">{{item.total_price}}</span>
					</el-col>
				</el-row>
				<div class="table">
					<el-table :data="formatTableData(item)" max-height='800' style="width: 100%;margin-bottom: 20px;" row-key="tableKey">
						<el-table-column type="expand" >
							<template slot-scope="props">
								<div v-if="props.row.goodsList&&props.row.goodsType!==2">
									<el-tag style="margin: 5px;" v-for="item in props.row.goodsList" :key="item.tableKey">
										<span v-if="props.row.goodsType===3">{{item.goodsName}} {{item.skuValue}}</span>
										{{item.customCode}}
										{{item.goods_sales_model===2?'(赠)':''}}
									</el-tag>
								</div>
								<div v-else>无条码</div>
							</template>
						</el-table-column>
						<el-table-column label="商品名称" width="320">
							<template slot-scope="scope">
								{{scope.row.goodsName}}
								{{scope.row.goods_sales_model===2?'(赠)':''}}
							</template>
						</el-table-column>
						<el-table-column prop="customCode" label="宠物" width="150">
							<template slot-scope="scope">
								{{scope.row.petName}}
							</template>
						</el-table-column>
						<el-table-column label="规格" width="150">
							<template slot-scope="scope">
								{{scope.row.skuValue}}
							</template>
						</el-table-column>
						<el-table-column label="单位" width="80">
							<template slot-scope="scope">
								{{scope.row.unit}}
							</template>
						</el-table-column>
						<el-table-column prop="price" label="标准价" width="100">
							<template slot-scope="scope">
								{{scope.row.originalPrice}}
							</template>
						</el-table-column>
						<el-table-column prop="activityName" label="活动" >
						</el-table-column>
						<el-table-column prop="price" label="优惠价" width="150">
							<template slot-scope="scope">
								{{scope.row.price}}
							</template>
						</el-table-column>
						<el-table-column prop="num" label="数量" width="100">
							<template slot-scope="scope">
								{{scope.row.num}}
							</template>
						</el-table-column>
						<el-table-column label="总金额" width="120">
							<template slot-scope="scope">
								{{scope.row.totalMoney}}
							</template>
						</el-table-column>
						<el-table-column prop="staff" label="销售人员" width="150">
						</el-table-column>
					</el-table>
				</div>
				<div>
					<span>总金额：{{total[index]}}</span>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				total:[],
				allTotal:0,
			}
		},
		computed:{
			unPayOrderList(){
				let list = this.$store.state.mendian.unPayOrderList;
				return list;
			},
			unPayOrderNoList(){
				let list = this.$store.state.mendian.unPayOrderNoList;
				return list;
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
			let list = this.unPayOrderList;
			for(let i=0;i<list.length;i++){
				if(this.unPayOrderNoList.indexOf(list[i].no)===-1){
					let total = 0;
					for(let a=0;a<list[i].order_item_list.length;a++){
						let item = list[i].order_item_list[a]
						total = this.$public.jia(total,this.$public.cheng(item.price,item.num))
					}
					this.total.push(total)
					this.allTotal = this.$public.jia(this.allTotal,list[i].total_price)
				}
			}
		},
		methods: {
			handleClose(){
				this.$emit('submit')
			},
			changeChecked(no){
				this.$store.commit("mendian/set_unPayOrderNoList",no)
				this.allTotal = 0;
				let list = this.unPayOrderList;
				for(let i=0;i<list.length;i++){
					if(this.unPayOrderNoList.indexOf(list[i].no)===-1){
						this.allTotal = this.$public.jia(this.allTotal,list[i].total_price)
					}
				}
			},
			formatTableData(detail){
				let tableData = []
				for(let i=0;i<detail.order_item_list.length;i++){
					let goods = detail.order_item_list[i];
					let one = {
						activityId: goods.activity_info&&goods.activity_info.activity_id, // 活动id
						activityName: goods.activity_info&&goods.activity_info.activity_name, // 活动名称
						goodsDosage: "", // 用量
						petId: goods.pets_info.pets_id, // 商品id
						petName: goods.pets_info.pets_name, // 商品名称
						goodsId: goods.goods_id, // 商品id
						goodsName: goods.goods_name, // 商品名称
						goodsType:  goods.goods_type,
						goodsUsage: "", // 用法
						isPay: detail.state, // 是否支付
						num:goods.num, // 数量
						originalPrice: goods.original_price, // 原价
						price: goods.price, // 现价
						remark: goods.remarks, // 备注
						model: goods.sku_value, // 规格
						skuValue: goods.sku_value, // 规格
						skus: goods.skus_id, // 规格
						totalMoney: this.$public.cheng(goods.num,goods.price), // 总价
						unit: goods.unit, // 单位
						staff: '',
						goods_sales_model:goods.goods_sales_model,  // 0老数据   1出售   2赠品
						goodsList: [], // children
					}
					if(goods.sales_list){
						for(let b=0;b<goods.sales_list.length;b++){
							one.staff+=goods.sales_list[b].sales_name+' '
						}
					}
					one.tableKey='tableKey_goods_one'+Math.random();
					if(goods.order_item_goods_list){
						for(let a=0;a<goods.order_item_goods_list.length;a++){
							let two = {
								tableKey:'tableKey_goods_two'+Math.random(),
								customCode: goods.order_item_goods_list[a].custom_code,
								activityId: "", // 活动id
								activityName: "", // 活动名称
								goodsDosage: "", // 用量
								goodsId: goods.order_item_goods_list[a].goods_id, // 商品id
								goodsName: goods.order_item_goods_list[a].goods_name, // 商品名称
								goodsType: goods.goods_type, // 1:商品；2:服务；3:套餐
								goodsUsage: "", // 用法
								isPay: detail.state, // 是否支付
								num: 1, // 数量
								model: goods.model, // 规格
								skus: goods.skus, // 规格
								unit: goods.unit, // 单位
								unit_id: goods.unit, // 单位
								outUnit: goods.out_unit, // 单位
								validityStopDate:goods.order_item_goods_list[a].validity_stop_date,
								goods_sales_model:goods.order_item_goods_list[a].goods_sales_model,  // 0老数据   1出售   2赠品
							}
							one.goodsList.push(two);
						}
					}
					// if(goods.goods_type==1){ // 商品
					// 	one.tableKey='tableKey_goods_one'+Math.random();
					// 	if(goods.order_item_goods_list){
					// 		for(let a=0;a<goods.order_item_goods_list.length;a++){
					// 			let two = {
					// 				tableKey:'tableKey_goods_two'+Math.random(),
					// 				customCode: goods.order_item_goods_list[a].custom_code,
					// 				activityId: "", // 活动id
					// 				activityName: "", // 活动名称
					// 				goodsDosage: "", // 用量
					// 				goodsId: goods.order_item_goods_list[a].goods_id, // 商品id
					// 				goodsName: goods.order_item_goods_list[a].goods_name, // 商品名称
					// 				goodsType: goods.goods_type, // 1:商品；2:服务；3:套餐
					// 				goodsUsage: "", // 用法
					// 				isPay: detail.state, // 是否支付
					// 				num: 1, // 数量
					// 				model: goods.model, // 规格
					// 				skus: goods.skus, // 规格
					// 				unit: goods.unit, // 单位
					// 				unit_id: goods.unit, // 单位
					// 				outUnit: goods.out_unit, // 单位
					// 				validityStopDate:goods.order_item_goods_list[a].validity_stop_date,
					// 				goods_sales_model:0,
					// 			}
					// 			one.goodsList.push(two);
					// 		}
					// 	}
					// }else if(goods.goods_type==2){ // 服务
					// 	one.tableKey='tableKey_service_one'+Math.random();
					// 	one.customCode='service'+i+goods.goods_name;
					// }else if(goods.goods_type==3){
					// 	one.tableKey='tableKey_group_one'+Math.random();
					// 	one.customCode='customCode_group_one'+Math.random();
					// 	if(goods.order_item_goods_list){
					// 		for(let a=0;a<goods.order_item_goods_list.length;a++){
					// 			let two = {
					// 				tableKey:'tableKey_goods_two'+Math.random(),
					// 				customCode: goods.order_item_goods_list[a].custom_code,
					// 				activityId: "", // 活动id
					// 				activityName: "", // 活动名称
					// 				goodsDosage: "", // 用量
					// 				goodsId: goods.order_item_goods_list[a].goods_id, // 商品id
					// 				goodsName: goods.order_item_goods_list[a].goods_name, // 商品名称
					// 				goodsType: goods.goods_type, // 1:商品；2:服务；3:套餐
					// 				goodsUsage: "", // 用法
					// 				isPay: detail.state, // 是否支付
					// 				num: 1, // 数量
					// 				originalPrice: goods.original_price, // 原价
					// 				price: goods.price, // 现价
					// 				remark: goods.remarks, // 备注
					// 				model: goods.sku_value, // 规格
					// 				skuValue: goods.order_item_goods_list[a].model, // 规格
					// 				skus: goods.skus_id, // 规格
					// 				totalMoney: (goods.num*goods.price).toFixed(2), // 总价
					// 				unit: goods.order_item_goods_list[a].unit, // 单位
					// 				validityStopDate:goods.order_item_goods_list[a].validity_stop_date,
					// 				returnState:false,
					// 			}
					// 			one.goodsList.push(two);
					// 		}
					// 	}
					// }
					tableData.push(one);
				}
				return tableData;
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.label{
				display: inline-block;width:100px;text-align: right;
			}
			.el-drawer__body{
				height: 100%;overflow-y:auto;padding-bottom:100px;
			}
		}
		
	}
	
</style>
